export default __webpack_public_path__ + "0b9d33cff3e1e0407e6c9f9d6fc52975.jpg";